<template>
  <Tippy
    ref="popover"
    :arrow="true"
    trigger="click"
    interactive
    theme="light"
    placement="bottom"
  >
    <template #trigger>
      <div class="sort-option-selected">
        <div
          class="font-weight-bold text-secondary"
          style="font-size: 10px; min-width: 180px"
        >
          {{ $t('general.groupBy') }}
        </div>
        <div
          class="first"
          style="font-size: 14px"
        >
          <span v-if="groupBy">
            <i :class="`${groupBy.icon} pr-1`" />
            {{ groupBy.text }}
          </span>
          <span v-else>-</span>
        </div>
      </div>
    </template>

    <div style="min-width: 180px">
      <div
        v-for="(s, i) in groupOptions"
        :key="s.key"
        class="sort-option text-left"
        :class="{ first: i === 0, active: groupKey === s.key }"
        @click="$emit('update:groupKey', s.key); $refs.popover.tippy().hide()"
      >
        <i :class="`${s.icon} pr-1`" />
        {{ s.text }}
      </div>
    </div>
  </Tippy>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    groupKey: String,
    subscriptions: Boolean,
  },
  computed: {
    ...mapGetters('shop', [
      'dailyOrderSchema',
      'monthlyOrderSchema',
    ]),
    groupBy() {
      return this.groupOptions.find((x) => x.key === this.groupKey);
    },
    groupOptions() {
      return [
        {
          key: 'none',
          icon: 'fal fa-ban',
          text: this.$t('shop.noGroup'),
        },
        {
          key: 'payers',
          icon: 'fal fa-users',
          text: this.$t('menu.payers'),
        },
        {
          key: 'productSets',
          icon: 'far fa-box',
          text: this.$t('shop.offer.offer'),
        },
        ...(this.dailyOrderSchema && !this.subscriptions ? [
          {
            key: 'day',
            icon: 'far fa-calendar',
            text: this.$t('time.day'),
          },
        ] : []),
        ...(this.monthlyOrderSchema && !this.subscriptions ? [
          {
            key: 'day',
            icon: 'far fa-calendar',
            text: this.$t('time.month'),
          },
        ] : []),
      ];
    },
  },
  created() {
    if (!this.groupBy) {
      this.$emit('update:groupKey', this.groupOptions[0].key);
    }
  },
};
</script>

<style lang="scss" scoped>
 @import '@/components/payers/style.scss';
</style>
